const transLookup = {
  closeDt: 'sale',
  leaseStDt: 'lease',
  incStYr: 'incexp',
  constYr: 'const'
}

/**
 * Get transaction type
 * @param  {Object} transaction document
 * @return {String}             transaction type
 */
export default function getTransactionType (trans) {
  for (const field in transLookup) {
    if (field in trans || (trans.has && trans.has(field))) return transLookup[field]
  }
}



// WEBPACK FOOTER //
// ./modules/utils/getTransactionType.js